<template>
  <b-container>
    <h2>{{ $t("fuelStock.title") }}</h2>
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-row>
      <router-link
        :to="`/checklist/Layout/form/fill/${$store.getters.formFuelEntraceId}`"
      >
        <b-button size="sm">
          {{ $t("fuelStockMovement.createEntry") }}
        </b-button>
      </router-link>
      <router-link
        :to="`/checklist/Layout/form/fill/${$store.getters.formFuelSupplyId}`"
      >
        <b-button class="ml-2" size="sm">
          {{ $t("fuelStockMovement.createSupply") }}
        </b-button>
      </router-link>
      <router-link
        :to="`/checklist/Layout/form/fill/${$store.getters.formFuelStockTransferId}`"
      >
        <b-button class="ml-2" size="sm">
          {{ $t("fuelStock.transfer") }}
        </b-button>
      </router-link>      

      <b-button
        size="sm"
        class="ml-2 btn-checklist cleanFilters"
        @click="filtersClean"
      >
        {{ $t("geral.cleanFilters") }}
      </b-button>
      <b-button
        size="sm"
        class="ml-2 btn-checklist cleanFilters"
        @click="$refs.table.refresh()"
      >
        <i
          class="material-icons"
          style="font-size: 18px; vertical-align: middle; margin-right: 5px"
        >
          refresh
        </i>
        {{ $t("geral.refresh") }}
      </b-button>
    </b-row>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.filterKey != 'actions'">
                <b-form-input
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>

        <template v-slot:cell(actions)="data">
          <router-link
            v-if="data.item.internalGasStation == null"
            :to="`././movements/list/${data.item.fuelTypeId}`"
          >
            <b-button size="sm" class="btn-checklist">
              {{ $t("fuelStock.movements") }}
            </b-button>
          </router-link>
          <router-link
            :to="`././movements/list/${data.item.fuelTypeId}/${data.item.internalGasStation}`"
          >
            <b-button size="sm" class="btn-checklist">
              {{ $t("fuelStock.movements") }}
            </b-button>
          </router-link>
        </template>
      </b-table>
    </b-row>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
  <script>
export default {
  name: "FuelStockList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          thStyle: "width: 170px",
        },
        {
          key: "fuelType",
          filterKey: "fuelType",
          label: "Tipo de combustível",
        },
        {
          key: "internalGasStation",
          filterKey: "internalGasStation",
          label: "Posto interno",
        },
        {
          key: "liters",
          filterKey: "liters",
          label: "Total de litros",
          thStyle: "width: 250px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "valuePerLiter",
          filterKey: "valuePerLiter",
          label: "Valor por Litro",
          thStyle: "width: 250px",
          thClass: "td-number",
          tdClass: "td-number",
        },
      ],
      tableFilters: {
        internalGasStation: "",
        fuelType: "",
        liters: "",
        valuePerLiter: "",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created() {},
  methods: {
    filtersClean() {
      this.tableFilters = {
        internalGasStation: "",
        fuelType: "",
        liters: "",
        valuePerLiter: "",
      };
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        internalGasStation: ctx.filter.internalGasStation,
        fuelType: ctx.filter.fuelType,
        liters: ctx.filter.liters,
        valuePerLiter: ctx.filter.valuePerLiter,
      };
      this.$apiVehicle
        .post("/fuelStock/paginate/", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>